import { useQuery } from "react-query";

import { fetchPlayTo3DFields } from "../api/ipdp";

export const PLAY_TO_3D_FIELDS_QUERY_KEY = "fetchPlayTo3DFields";

///hook to fetch ipdb fields
export default function usePlayTo3DFields(source: string) {
  const { data, isLoading, isError, refetch } = useQuery(
    [PLAY_TO_3D_FIELDS_QUERY_KEY, source],
    () => fetchPlayTo3DFields(source),
    {
      enabled: false
    }
  );

  return {
    data,
    isLoading,
    isError,
    refetch
  };
}
